var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matching-card-background"},[_c('picture',[_c('img',{attrs:{"src":_vm.backgroundSource,"alt":_vm.companyName}})])])}
var staticRenderFns = []

export { render, staticRenderFns }